__turbopack_context__.v({
  "className": "oswald_7268f646-module__gBoAGG__className",
});
